module.exports = __webpack_public_path__ + "img/warning-token-expired-icon.00a3c458.svg";